import { Heading } from '@chakra-ui/react';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const OrganizationHeading = () => {
  const { selectedOrganization } = useAppContext();

  return <Heading>{selectedOrganization?.name}</Heading>;
};
